import { render, staticRenderFns } from "./AppointmentListAddNew.vue?vue&type=template&id=318780d8"
import script from "./AppointmentListAddNew.vue?vue&type=script&lang=js"
export * from "./AppointmentListAddNew.vue?vue&type=script&lang=js"
import style0 from "./AppointmentListAddNew.vue?vue&type=style&index=0&id=318780d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports